import { createAsyncThunk } from '@reduxjs/toolkit';
import { PropertySubCategory } from '../../../client/services';
import { toastHandler } from '../../../utils/toastHandler';
import {
  CreatePatchPropertySubCategory,
  FindPropertySubCategory,
  GetPropertySubCategory,
} from './interface';

export const findPropertySubCategory = createAsyncThunk(
  'propertySubCategory/findPropertySubCategory',
  async (values: FindPropertySubCategory, { rejectWithValue }) => {
    try {
      const response = await PropertySubCategory.find({
        query: values,
      });

      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const createPropertySubCategory = createAsyncThunk(
  'propertySubCategory/createPropertySubCategory',
  async (values: CreatePatchPropertySubCategory, { rejectWithValue }) => {
    try {
      const response = await PropertySubCategory.create(values);
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const patchPropertySubCategory = createAsyncThunk(
  'propertySubCategory/patchPropertySubCategory',
  async (
    { id, ...values }: CreatePatchPropertySubCategory,
    { rejectWithValue }
  ) => {
    try {
      const response = await PropertySubCategory.patch(id, values);
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const getPropertySubCategory = createAsyncThunk(
  'propertySubCategory/getPropertySubCategory',
  async ({ id }: GetPropertySubCategory, { rejectWithValue }) => {
    try {
      const response = await PropertySubCategory.get(id);

      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);
